<template>
  <div class="main" style="background: #f5f5f5">
    <img class="bg_img" src="../../assets/img/mine/bg_mine_top.png" alt="" />
    <div class="top-box">
      <div class="header">
        <div class="msg-box" @click="historyNotice('云端钱包公告')">
          <img class="msg" src="../../assets/img/mine/icon_msg.png" alt="" />
        </div>
        <div @click="setUp()">
          <img
            class="setting"
            src="../../assets/img/mine/icon_setting.png"
            alt=""
          />
        </div>
      </div>
      <!--    用户信息模块-->
      <div
        class="userinfo-module"
        v-if="showInfo"
        @click="$router.push('/edit-info')"
      >
        <img v-if="userInfo.avatar" class="avatar" :src="userInfo.avatar" />
        <img v-else class="avatar" src="../../assets/img/avatar.jpg" />
        <div class="right-info-box">
          <div v-if="userInfo.user_nickname" class="name">
            {{ userInfo.user_nickname }}
          </div>
          <div v-else class="name">
            Hi,{{ userInfo.mobile || userInfo.user_email }}
          </div>
          <div class="id">ID:{{ userInfo.id }}</div>
        </div>
        <span class="right">></span>
      </div>
      <!--    菜单模块-->
      <div class="menu-module">
        <div>
          <router-link to="/">
            <img src="../../assets/img/mine/wallet_mgr.png" alt="" />
          </router-link>
          <div class="txt">{{ $t("钱包管理") | filter_menu }}</div>
        </div>
        <div>
          <router-link to="/Zixun">
            <img src="../../assets/img/mine/news.png" alt="" />
          </router-link>
          <div class="txt">{{ $t("每日快讯") | filter_menu }}</div>
        </div>
        <!--      <div>-->
        <!--        <router-link to="/share">-->
        <!--          <img src="../../assets/img/mine/invite_reward.png" alt="">-->
        <!--        </router-link>-->
        <!--        <span>{{ $t('邀请奖励') }}</span>-->
        <!--      </div>-->
        <div>
          <a :href="initInfo.system_customer_service">
            <img src="../../assets/img/mine/contact_kefu.png" alt="" />
          </a>
          <div class="txt">{{ $t("联系客服") | filter_menu }}</div>
        </div>
      </div>
    </div>

    <!--    第一部分菜单-->
    <div class="fast-menu-module">
      <mt-cell :title="$t('实名认证')" is-link @click.native="goRealme">
        <span :class="{ dl_main_color: userInfo.user_auth_status === 3 }">
          <template v-if="userInfo.auth_id === 1">{{
            $t("请先设置支付密码")
          }}</template>
          <template v-else-if="userInfo.user_auth_status === 0">{{
            $t("立即认证")
          }}</template>
          <template v-else-if="userInfo.user_auth_status === 1">{{
            $t("已认证")
          }}</template>
          <template v-else-if="userInfo.user_auth_status === 2">{{
            $t("审核中")
          }}</template>
          <template v-else-if="userInfo.user_auth_status === 3">{{
            $t("认证失败")
          }}</template>
        </span>
      </mt-cell>
      <mt-cell :title="$t('修改密码')" is-link to="/change-password"> </mt-cell>
      <!-- <mt-cell :title="$t('PIN码')" is-link @click.native="goPin">
        <span class="dl_main_color">{{ ifPin ? $t("已开启(重置)") : $t("未开启") }}</span>
      </mt-cell> -->
      <mt-cell :title="$t('默认货币')" is-link :value="currency" to="/huobi">
      </mt-cell>
      <!-- <mt-cell :title="$t('行情选项')" is-link
               :value="hangqing == '0' ? $t('绿涨红跌') : $t('红涨绿跌')" to="/redgreen">
      </mt-cell> -->
      <mt-cell
        :title="$t('默认语言')"
        is-link
        :value="this.language_title[language]"
        to="/setlanguage"
      >
      </mt-cell>
    </div>
    <!--    第二部分菜单-->
    <div class="fast-menu-module menu-module2">
      <mt-cell :title="$t('服务协议')" is-link to="/user-agreement"> </mt-cell>
      <mt-cell
        :title="$t('隐私政策')"
        is-link
        :to="initInfo.system_privacy_policy"
      >
      </mt-cell>
      <mt-cell
        :title="$t('帮助中心')"
        is-link
        :to="initInfo.system_help_center"
      >
      </mt-cell>
      <mt-cell :title="$t('加入社群')" is-link to="/shequn"> </mt-cell>
    </div>
    <div class="version">Version 1.0.4</div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { validateEmpty } from "@/utils/validate";
import store from "@/store";
import { httpGetInitInfo, httpGetUserInfo } from "@/api/login";

export default {
  name: "Index",
  components: { Toast },
  data() {
    return {
      score: "0 " + this.$t("积分"),
      userInfo: "",
      currency: this.$store.getters.currency,
      hangqing: this.$store.getters.hangqing,
      initInfo: "",
      showInfo: false,
      language_title: {
        tw: "繁體中文",
        zh: "简体中文",
        en: "English",
        ko: "한국어",
        ja: "日本語",
        hk: "繁體中文",
      },
    };
  },
  filters: {
    filter_menu(value) {
      if (value.toString().length > 5) {
        return value.toString().substr(0, 5) + "...";
      } else {
        return value.toString();
      }
    },
  },
  methods: {
    goPin: function () {
      if (this.ifPin) {
        this.$router.push("/pincheck");
      } else {
        this.$router.push("/pinset");
      }
    },

    // 实名认证
    goRealme() {
      if (this.userInfo.auth_id === 1) {
        this.$router.push("/SetPayPassword");
      } else if (this.userInfo.user_auth_status === 0) {
        // 跳转立即认证界面
        this.$router.push("/levelThree");
      } else {
        // 认证信息界面
        this.$router.push(
          "/realState?status=" + this.userInfo.user_auth_status
        );
      }
    },
    historyNotice(title) {
      this.$router.push({ path: "/historyNotice", query: { title: title } });
    },
    setUp() {
      this.$router.push("/setUp");
    },
    info() {
      httpGetInitInfo()
        .then((res) => {
          //store.dispatch('setInitInfo', res.data);
          this.initInfo = res.data;
        })
        .catch((e) => {});
      // 获取用户信息
      httpGetUserInfo()
        .then((res) => {
          //store.dispatch('setInitInfo', res.data);
          this.userInfo = res.data;
          console.log(this.userInfo);
          if (this.userInfo.id) {
            this.showInfo = true;
            this.score = this.userInfo.score + " " + this.$t("积分");
          } else {
            this.showInfo = false;
          }
        })
        .catch((e) => {});
    },
    toPersonal(id) {
      this.$router.push({ path: "/to_personal", query: { id: id } });
    },
  },
  computed: {
    ifPin: function () {
      return validateEmpty(this.$store.getters.pin) ? false : true;
    },
    language: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    "$store.state.currency": function (val, oldVal) {
      this.currency = val;
    },
    "$store.state.hangqing": function (val, oldVal) {
      this.hangqing = val;
    },
    "$store.state.userInfo": function (val, oldVal) {
      this.userInfo = val;
    },
  },
  activated: function () {
    this.info();
    if (this.$route.query.result) {
      this.$router.push("/pinset");
    }
  },
};
</script>

<style scoped lang="less">
.bg_img {
  width: 100%;
  height: 200px;
  position: absolute;
}

.top-box {
  position: relative;
}

.header {
  height: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 14px;

  div {
    width: 32px;
  }

  div.msg-box {
    margin-right: 5px;
  }

  img {
    display: block;
    margin: 0 auto;
  }

  img.msg {
    width: 20px;
    height: 19px;
  }

  img.setting {
    width: 18px;
    height: 20px;
  }
}

.userinfo-module {
  position: relative;
  padding: 20px 19px;
  display: flex;
  justify-content: flex-start;

  .avatar {
    width: 33px;
    height: 33px;
    border-radius: 50%;
  }

  .right-info-box {
    margin-left: 15px;
    color: white;

    .name {
      font-size: 23px;
      font-weight: 500;
      width: 210px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .id {
      font-size: 13px;
      font-weight: 500;
      margin-top: 8px;
    }
  }
}

.menu-module {
  background: #ffffff;
  box-shadow: 0px 2px 11px 0px rgba(135, 135, 135, 0.18);
  border-radius: 10px;
  margin: 18px 15px 0;
  padding: 25px 28px 20px;
  box-sizing: border-box;

  display: flex;
  justify-content: space-between;

  img {
    width: 49px;
    height: 49px;
    display: block;
    margin: 0 auto;
  }

  div.txt {
    font-size: 12px;
    font-family: PingFang;
    font-weight: 500;
    color: #333333;
    margin: 12px auto 0;
    text-align: center;
  }
}

.fast-menu-module {
  background: #ffffff;
  border-radius: 5px;
  margin: 14px 15px 0;
  box-sizing: border-box;

  /deep/ .mint-cell {
    height: 50px;
  }

  /deep/ .mint-cell img {
    width: 21px;
    height: 21px;
  }

  /deep/ .mint-cell-text {
    font-size: 14px;
    font-family: PingFang;
    font-weight: 500;
    color: #333333;
  }

  /deep/ .mint-cell-value.is-link span {
    font-size: 14px;
    font-family: PingFang;
    font-weight: 500;
    color: #999999;
  }
}

.menu-module2 {
  margin-bottom: 20px;
}
.dl_main_color {
  color: red !important;
}
.right {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  color: #ffffff;
}
/deep/.mint-cell-wrapper {
  padding: 0 30px 0 10px;
}
/deep/.mint-cell-value.is-link {
  max-width: 199px;
  margin-right: 0px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
// /deep/.mint-cell-title {
//   flex: none;
//   margin-right: 10px;
// }

.version{
  text-align: center;
  padding-bottom: 20px;
  font-size: 12px;
  color: #999;
}
</style>
